import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/rootReducer";
import { useEffect } from "react";
import { getUserInfo } from "@/redux/user/selector";
import { getUserInfoRequestThunk } from "@/redux/user/thunk";
import { setUserInfoFetchState } from "@/redux/user/actions";

export default function useGetUserInfoRequest() {
	const dispatch = useDispatch();
	const { isAuthenticated } = useSelector((state: RootState) => state.auth);
	const userInfo = useSelector(getUserInfo);

	useEffect(() => {
		if (!userInfo && isAuthenticated) {
			dispatch(getUserInfoRequestThunk());
		}

		return () => {
			dispatch(setUserInfoFetchState("READY"));
		};
	}, [isAuthenticated]);
}
